import { createContext } from 'react';
import { ExtendedUser } from '../Types';
import { CCXOverallTabTableDataItem } from './CCXDetails/CCXDetailsTab';

interface IPerformancePortalContext {
  dashboardFilters?: Partial<{
    verticalValue: string;
    skillValue: string;
    channelValue: string;
    segmentValue: string;
    weekValue: string;
    marketplaceValue: string;
    verticalOptions: string[];
    skillOptions: string[];
    channelOptions: string[];
    segmentOptions: string[];
    weekOptions: string[];
    marketplaceOptions: string[];
    filterVerticalValue: string;
  }>;
  ccxRatings?: string;
  passedProfile?: ExtendedUser;
  passedCCXUserID?: string;
  // This is a contactID => {} map
  // each contactID has a different set of data, but we want to cache to reduce api calls
  ccxForContactData?: {
    [key: string]: Array<Omit<CCXOverallTabTableDataItem, 'starRating'>>;
  };
}

const PerformancePortalContext = createContext<{
  performancePortalContextValue?: IPerformancePortalContext;
  setPerformancePortalContextValue?: (arg: IPerformancePortalContext) => void;
  clearPerformancePortalContextValue: () => void;
  refetchProfiles?: () => void;
}>({
  clearPerformancePortalContextValue: () => {},
});

export default PerformancePortalContext;
